import { useContext } from 'react'

import { V2ConfigurationContext } from 'contexts/Configuration'

import PoweredBySidechefImg from 'images/powered_by_sidechef.svg'

const PoweredBy = () => {
  const { disablePoweredBy } = useContext(V2ConfigurationContext)

  if (disablePoweredBy) return null

  return <PoweredBySidechefImg width={168} height={20} style={{ alignSelf: 'center' }} />
}

export default PoweredBy
